import { render, staticRenderFns } from "./Types.vue?vue&type=template&id=08546799&"
import script from "./Types.vue?vue&type=script&lang=js&"
export * from "./Types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08546799')) {
      api.createRecord('08546799', component.options)
    } else {
      api.reload('08546799', component.options)
    }
    module.hot.accept("./Types.vue?vue&type=template&id=08546799&", function () {
      api.rerender('08546799', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/Types/Types.vue"
export default component.exports